import { LinkUI } from "./common_links";

function FooterSection() {
  return (
    <footer className="w-full border-t border-gray-200 bg-gray-50 px-4 py-6 text-center">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center justify-center gap-3 text-sm leading-7 text-gray-700 md:text-base">
        <div>
          Ask us any question on our reddit group
          {
            LinkUI({
              url: "https://www.reddit.com/r/LowLevelDesign/",
              text: "r/LowLevelDesign"
            })
          } <br />

        </div>

        <div className="text text-gray-700 text-center mx-6 md:mx-0">
          Reach us at : &nbsp;
          <span className="font-semibold text-blue-600">contact@codezym.com</span>
          <br />

          
        </div>

        <div className="flex flex-row-responsive items-center justify-center gap-3">
          <LinkUI url="/terms" text="Terms and Conditions" />
          &nbsp; &nbsp;
          <LinkUI url="/privacy" text="Privacy Policy" />
        </div>
      </div>
    </footer>
  );
}

export {FooterSection}